import api from "./api";
import { toastMessage } from "../utils/Utils";

const { USERS_LOAD, USERS_RESPONSE, UPDATE_UNIQUE_USER } = require("./types");

export const getUsers = (page,limit, params) => {
    return dispatch => {
        dispatch({ type: USERS_LOAD, load: true })
        var formData = new FormData()
        const query = []
        for( let i in params)
            if(params[i])
                query.push(i+"="+params[i])
        // formData.append(i, params[i])
        api.get(`user/list/${page}/${limit}${query.length > 0 && '?'+query.join('&')}`, formData)
        .then( res => {
            const { paginate } = res.data.payload
            let payload = {
                loading_users: false,
                paginate
            }

            dispatch({ type: USERS_RESPONSE, payload })
            window.feather.replace()
        })
        .catch( error => {
            const { message } = error
            dispatch({ type: USERS_LOAD, load: false })
            toastMessage('error',message)
        })
    }
}

export const deleteUser = () => {
    return dispatch => {

    }
}

export const updateUniqueUser = (user) => dispatch => dispatch({ type: UPDATE_UNIQUE_USER, user})
